// @flow
/* eslint-disable */

import React from 'react';

import { translate, translateToHTML } from '../../../base/i18n';
import { connect } from '../../../base/redux';
import { Footer } from '../../../welcome/components/Footer';
import { Header } from '../../../welcome/components/Header';

import AbstractUserMediaPermissionsOverlay, { abstractMapStateToProps }
    from './AbstractUserMediaPermissionsOverlay';
import OverlayFrame from './OverlayFrame';

declare var interfaceConfig: Object;

/**
 * Implements a React Component for overlay with guidance how to proceed with
 * gUM prompt.
 */
class UserMediaPermissionsOverlay extends AbstractUserMediaPermissionsOverlay {
    /**
     * Implements React's {@link Component#render()}.
     *
     * @inheritdoc
     * @returns {ReactElement}
     */
    render() {
        const { browser, t, interfaceConfig } = this.props;

        // const preMeetingStyle = interfaceConfig?.applyMeetingSettings === true ? { background: `${interfaceConfig?.DEFAULT_BACKGROUND}` } : {};

        return (
            <OverlayFrame>
                <Header 
                    prejoin = {false} />
                <div
                    className = 'container'
                    style = {{ maxWidth: '1120px!important', marginTop: '5%', }}>
                    <div className = 'row'>
                        <div className = 'col-m-12 col-sm-12'>
                            <br /><br /><br />
                            <div
                                className='text-center'
                                style = {{
                                    width: '80%',
                                    maxWidth: '800px',
                                    borderRadius: '10px',
                                    margin: 'auto',
                                    backgroundColor: '#f6f6f6',
                                    color: '#000',
                                    padding: '20px'
                                }}>

                                <i
                                    style = {{
                                        fontSize: '64px',
                                        color: '#4f8e7b'
                                    }}
                                    className = 'bx bx-video' /><i
                                    style = {{
                                        fontSize: '64px',
                                        color: '#4f8e7b'
                                    }}
                                    className = 'bx bxs-microphone' /><br />

                                <h4 style = {{ marginTop: '10px' }}>
	Conference requires access to your microphone and camera.</h4>

                                <hr /><h6>
Select <b><i>Allow</i></b> when your browser asks for permissions.</h6>


                            </div>
                            <br /><br />


                        </div>


                    </div>
                </div>
                <Footer
                    prejoin = { false }
                    style = {{
                        width: '100%' }} />
            </OverlayFrame>
        );
    }

    /**
     * Renders the policy logo.
     *
     * @private
     * @returns {ReactElement|null}
     */
    _renderPolicyLogo() {
        const policyLogoSrc = interfaceConfig.POLICY_LOGO;

        if (policyLogoSrc) {
            return (
                <div className = 'policy__logo'>
                    <img src = { policyLogoSrc } />
                </div>
            );
        }

        return null;
    }
}

export default translate(
    connect(abstractMapStateToProps)(UserMediaPermissionsOverlay));
